import { omanConfig } from '../../oman.config'
import type { TOmanRegion } from '../../types/oman.types'

export const asRecord = (value: unknown): Record<string, unknown> | undefined =>
    value && typeof value === 'object' && !Array.isArray(value) ? (value as Record<string, unknown>) : undefined

export const getDetailPage = (rawFormat: unknown): Record<string, unknown> => {
    const raw = asRecord(rawFormat)
    const ushop = asRecord(raw?.ushop)
    return asRecord(ushop?.detail_page) ?? asRecord(asRecord(ushop?.u23)?.detail_page) ?? {}
}

export const hasDeliveryAddress = (rawFormat: unknown): boolean => {
    const detailPage = getDetailPage(rawFormat)
    return Boolean(detailPage.address || detailPage.address1 || (detailPage.city && detailPage.state))
}

export const getPickupAddressLine = () => [omanConfig.pickup.address, omanConfig.pickup.city, omanConfig.pickup.country].filter(Boolean).join(', ')

export const joinAddressLine = (values: Array<string | undefined>): string => values.filter(Boolean).join(', ')

export const getRegionDisplayName = (stateValue: string | undefined, regions: TOmanRegion[]): string => {
    if (!stateValue) return ''
    const region = regions.find(item => item.name === stateValue || item.value === stateValue || item.code === stateValue || item.id === stateValue)
    return region?.name ?? stateValue
}
